import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'rc-cookies';

export default function CookieBanner() {
  const [decision, setDecision] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  });
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(!decision);

  useEffect(() => {
    if (decision) return;
    const t = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(t);
  }, [decision]);

  if (!mounted) return null;

  function handle(action) {
    try {
      localStorage.setItem(STORAGE_KEY, action);
    } catch {
      // ignore
    }
    setDecision(action);
    setVisible(false);
    setTimeout(() => setMounted(false), 600);
  }

  return (
    <div
      className={`cookie-banner${visible ? ' show' : ''}`}
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <div className="cookie-text">
        <strong>Usamos cookies 🍪</strong>
        Solo las necesarias para que la web funcione y para entender qué te interesa. Más info en
        nuestra <Link to="/privacidad">política de privacidad</Link>.
      </div>
      <div className="cookie-actions">
        <button className="cookie-btn ghost" onClick={() => handle('reject')}>
          Rechazar
        </button>
        <button className="cookie-btn primary" onClick={() => handle('accept')}>
          Aceptar
        </button>
      </div>
    </div>
  );
}
